import React, { useEffect, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { ArrowHookUpLeftRegular, SaveMultipleFilled } from '@fluentui/react-icons';
import BoardingStructure from '../../templates/BoardingStructure';
import {
  Button,
  MenuButton,
  Label,
  makeStyles,
  Divider,
  Spinner
} from '@fluentui/react-components';
import {
  Dialog,
  DialogTrigger,
  DialogSurface,
  DialogTitle,
  DialogBody,
  DialogActions,
  DialogContent,
  Text,
} from '@fluentui/react-components';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { useMsal, useAccount } from '@azure/msal-react';
import { silentRequest } from '../../../../authConfig';
const API_URL = process.env.REACT_APP_API_URL

const useStyles = makeStyles({
  label: { fontSize: '15px', fontWeight: 'lighter',color:'black' },
  value: { fontSize: '18px', fontWeight: 'bold', color: 'black' }
});


const CompanyDataPreview = ({ setCurrentStep, setCompanyIdDetect }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const classes = useStyles();
  const location = useLocation();
  const data = location.state;
  const { instance, accounts } = useMsal();
  const account = useAccount(accounts[0] || {});

  const companyData = [
    { label: 'เลขประจำตัวผู้เสียภาษี 13 หลัก', value: data?.taxId },
    { label: 'สำนักงานใหญ่/สาขา', value: data?.branchText },
  ];

  const companyName = [
    { label: 'ชื่อบริษัท', value: data?.name },
  ];

  const companyAddress = [
    { label: 'เลขที่อาคาร', value: data?.buildingNumber },
    { label: 'ที่อยู่', value: data?.address },
    { label: 'ถนน', value: data?.streetName },
    { label: 'จังหวัด', value: data?.province.text },
    { label: 'อำเภอ/เขต', value: data?.district.text },
    { label: 'ตำบล/แขวง', value: data?.subDistrict.text },
    { label: 'รหัสไปรษณีย์', value: data?.postcode }
  ];

  const companyContacts = [
    { label: 'เบอร์โทร', value: data?.phone },
    { label: 'อีเมล', value: data?.email },
  ];

  const companyVatRegister = [
    { label: 'จดทะเบียนภาษีมูลค่าเพิ่ม', value: data?.registerVat }
  ]

  const [open, setOpen] = React.useState(false);
  const [isLoading, setIsLoading] = useState(true);



  useEffect(() => {

    console.log(
      'Company:',
      data?.name,
      '\nbuildingNumber:',
      data?.buildingNumber,
      '\naddress:',
      data?.address,
      '\nProvince:',
      data?.province,
      '\nDistrict:',
      data?.district,
      '\nSubDistrict:',
      data?.subDistrict,
      '\nPostCode:',
      data?.postcode,
      '\nPhone:',
      data?.phone,
      '\nTaxId:',
      data?.taxId,
      '\nBranch:',
      data?.branchNumber,
      '\nLanguage:',
      data?.language,
      '\nTemplates',
      data?.templates
    );

    if (data){
      setIsLoading(false)
    }

    // eslint-disable-next-line
  }, [])


  const handleSubmit = async () => {
    setIsLoading(true)

    console.log(
      'Company:',
      data?.name,
      '\nid:',
      data?.id,
      '\nbuildingNumber:',
      data?.buildingNumber,
      '\naddress:',
      data?.address,
      '\nProvince:',
      data?.province,
      '\nDistrict:',
      data?.district,
      '\nSubDistrict:',
      data?.subDistrict,
      '\nPostCode:',
      data?.postcode,
      '\nPhone:',
      data?.phone,
      '\nTaxId:',
      data?.taxId,
      '\nBranch:',
      data?.branchNumber
    );


    instance
      .acquireTokenSilent({ ...silentRequest, account: account })
      .then(async (tokenResponse) => {
        try {
          const response = await axios.post(
            API_URL + '/etax/companies',
            {
              address: data?.address,
              branchNumber: data?.branchNumber,
              branchText: data?.branchText,
              buildingNumber: data?.buildingNumber,
              districtCode: data?.district.key,
              districtName: data?.district.text,
              districtPrefix: data?.districtPrefix,
              email: data?.email,
              name: data?.name,
              phone: data?.phone,
              phoneCountryCode: '+66',
              postcode: data?.postcode,
              provinceCode: data?.province.key,
              provinceName: data?.province.text,
              provincePrefix: data?.provincePrefix,
              streetName: data?.streetName,
              streetPrefix: data?.streetPrefix,
              subDistrictCode: data?.subDistrict.key,
              subDistrictName: data?.subDistrict.text,
              subDistrictPrefix: data?.subDistrictPrefix,
              taxId: data?.taxId,
              taxNumberType: 'TXID',
              language: data?.language,
              registerVat: data?.registerVat,
              unstructure: false,
            },
            {
              headers: {
                Authorization: 'Bearer ' + tokenResponse.accessToken,
                'Content-Type': 'application/json',
              },
            }
          );

          console.log('POST response:', response);
          window.scrollTo(0, 0);
          const companyId = response.data.id;
          if (!companyId) {
            throw new Error('Failed to retrieve companyId from sessionStorage');
          }
          sessionStorage.setItem('companyId', companyId);
          console.log('companyId saved:', companyId);

          const responseCreate = await axios.get(`${API_URL}/templates`, {
            headers: {
              Authorization: 'Bearer ' + tokenResponse.accessToken,
              cid: companyId,
            },
          });

          console.log('GET responseCreate:', responseCreate);

          if (responseCreate.status === 200) {
            console.log('Templates successfully created');

            const formData = new FormData();
            if (data?.companyLogo) {
              formData.append('logo', data.companyLogo);
            }
            if (data?.companySignature) {
              formData.append('signature', data.companySignature);
            }

            try {
              const putResponse = await axios.put(
                `${API_URL}/templates?templateNumber=${data?.templates.styleId}&documentType=all`,
                formData,
                {
                  headers: {
                    cid: companyId,
                    Authorization: 'Bearer ' + tokenResponse.accessToken,
                  },
                }
              );

              console.log('PUT response:', putResponse);

              if (putResponse.data) {
                console.log('PUT success:', putResponse.data.message);
              }
            } catch (error) {
              console.error('Error in PUT request:', error);
            }
            setCompanyIdDetect(companyId)
            setCurrentStep(6);
            setIsLoading(false);
            history.push({
              pathname: '/boarding/complete',
              state: {
                templates: data.templates,
              },
            });
            
          }
        } catch (error) {
          console.error('Error in POST or GET request:', error);
          window.scrollTo(0, 0);
        }
      })
      .catch((error) => {
        console.error('Token acquisition failed:', error);
      });
    }


  return (
    <BoardingStructure>
      <div style={{display: "flex",justifyContent: "center"}}>

        <div style={{
          marginTop: "17px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}>

          <div
            style={{
              display: "flex",
              width: "100%",
              height: "30px",
              marginBottom: "17px",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <MenuButton
              appearance="primary"
              menuIcon={null} icon={<SaveMultipleFilled />}
              onClick={() => setOpen(true)}
              style={{ marginRight: "10%" }}
              disabledFocusable={isLoading}
            >
              {t('boarding.confirm')}
            </MenuButton>

            <Dialog
              modalType="modal"
              open={open}
              onOpenChange={(event, data) => {
                setOpen(data.open);
              }}
            >
              <DialogSurface className="fluentui-dialog">
                <DialogBody className="dialog-body">
                  <DialogTitle>
                    {" "}
                    {t('boarding.confirmHeaderSetUp')}
                  </DialogTitle>
                  <DialogContent>

                    {t("boarding.confirmSetUp")}

                  </DialogContent>
                  <DialogActions>
                    <DialogTrigger>
                      <Button
                        appearance="primary"
                        className="button-dialog"
                        onClick={() => {
                          handleSubmit();
                        }}
                      >
                        {t("templatesSelector.confirm")}
                      </Button>
                    </DialogTrigger>

                    <DialogTrigger disableButtonEnhancement>
                      <Button appearance="secondary" className="button-dialog">
                        {t("templatesSelector.cancel")}
                      </Button>
                    </DialogTrigger>
                  </DialogActions>
                </DialogBody>
              </DialogSurface>
            </Dialog>
            <MenuButton
              appearance="secendary"
              style={{ alignSelf: "center", }}
              icon={<ArrowHookUpLeftRegular />}
              disabledFocusable={isLoading}
              menuIcon={null}
              onClick={() => {
                history.push({
                  pathname: "/boarding/company/form",
                  state: {
                    dataBack: true,
                    templates: data.templates,
                    taxId: data?.taxId,
                    branchNumber: data?.branchNumber,
                    branchText: data?.branchText,
                    name: data?.name,
                    buildingNumber: data?.buildingNumber,
                    address: data?.address,
                    streetPrefix: data?.streetPrefix,
                    streetName: data?.streetName,
                    provincePrefix: data?.provincePrefix,
                    province: data?.province,
                    districtPrefix: data?.districtPrefix,
                    district: data?.district,
                    subDistrictPrefix: data?.subDistrictPrefix,
                    subDistrict: data?.subDistrict,
                    postcode: data?.postcode,
                    phone: data?.phone,
                    email: data?.email,
                    registerVat: data?.registerVat,
                    language: data?.language,
                    companyLogo:data?.companyLogo,
                    companySignature:data?.companySignature
                  },
                });
              }}
              
            >
              {t('boarding.back')}
            </MenuButton>
          </div>
        </div>
      </div>

      {isLoading ? 
      <Spinner label={t("boarding.loading")} style={{ height: "300px" }} ></Spinner>
        :
        <div
          style={{
            width: '650px',
            padding: '40px',
            backgroundColor: 'white',
            borderRadius: '8px',
          }}
          tokens={{ childrenGap: 20 }}
        >
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }} >

            <div
              style={{
                display: 'flex',
                width: '100%',
                justifyContent: 'space-between',
                marginTop: '2%',
              }}
            >
              <div style={{ display: 'flex', width: '48%', justifyContent: "space-between" }}>
                <Label
                  size="extra-Large"
                  weight="bold"
                  styles={{ fontWeight: '800', color: '#323130', }}
                >
                  <Text className={classes.label} font="base" style={{color:"black"}} >{t('company.taxId')}</Text>
                </Label>

              </div>

              <div style={{ display: 'flex', width: '48%', justifyContent: "space-between" }}>
                <Label
                  size="large"
                  weight="regular"
                  styles={{ fontWeight: '800', color: '#323130' }}
                >
                  <Text className={classes.label} as="b">{t('boarding.branch')}</Text>
                </Label>
              </div>
            </div>
            <div
              style={{
                display: 'flex',
                width: '100%',
                justifyContent: 'space-between',
                marginTop: '1%',
              }}
            >
              <div style={{ display: 'flex', width: '48%', justifyContent: "space-between" }}>
                <Text className={classes.value}>{companyData[0].value}</Text>
              </div>
              <div style={{ display: 'flex', width: '48%', justifyContent: "space-between" }}>
                <Text className={classes.value}>{companyData[1].value}</Text>
              </div>
            </div>
            <Divider style={{ marginTop: '2.5%', marginBottom: "2.5%" }} />
            <div
              style={{
                display: 'flex',
                width: '100%',
              }}
            >
              <div style={{ display: "flex", width: "100%", justifyContent: "space-between" }} >
                <Label size="large" weight="regular" styles={{ width: '100%', fontWeight: '800', color: '#323130' }} >
                  <Text className={classes.label}> {t('company.name')}</Text>
                </Label>
              </div>
            </div>
            <div
              style={{
                display: 'flex',
                width: '100%',
                marginTop: '1%',
              }}
            >
              <div style={{ display: "flex", width: "100%", justifyContent: "space-between" }} >
                <Text className={classes.value}>{companyName[0].value}</Text>
              </div>
            </div>

            <Divider style={{ marginTop: '3%', marginBottom: "3%" }} />
            <div
              style={{
                display: 'flex',
                width: '100%',
                justifyContent: 'space-between',
              }}
            >
              {/* รายการแรก */}
              <div style={{ display: 'flex', width: '48%', justifyContent: "space-between" }}>
                <Label
                  size="large"
                  weight="regular"
                  styles={{ fontWeight: '800', color: '#323130' }}
                >
                  <Text className={classes.label}>{t('company.buildingNumber')}</Text>
                </Label>

              </div>

              <div style={{ display: 'flex', width: '48%', justifyContent: "space-between" }}>
                <Label
                  size="large"
                  weight="regular"
                  styles={{ fontWeight: '800', color: '#323130' }}
                >
                  <Text className={classes.label}>{t('company.address')}</Text>
                </Label>
              </div>
            </div>
            <div
              style={{
                display: 'flex',
                width: '100%',
                justifyContent: 'space-between',
                marginTop: '1%',
              }}
            >
              <div style={{ display: 'flex', width: '48%', justifyContent: "space-between" }}>

                <Text className={classes.value}>{companyAddress[0].value}</Text>
              </div>

              <div style={{ display: 'flex', width: '48%', justifyContent: "space-between" }}>

                <Text className={classes.value}>{companyAddress[1].value}</Text>
              </div>
            </div>

            <div
              style={{
                display: 'flex',
                width: '100%',
                justifyContent: 'space-between',
                marginTop: '2%',
              }}
            >
              <div style={{ display: 'flex', width: '48%', justifyContent: "space-between" }}>
                <Label
                  size="large"
                  weight="regular"
                  styles={{ fontWeight: '800', color: '#323130' }}
                >
                  <Text className={classes.label}>{t('company.streetName')}</Text>
                </Label>
              </div>

              <div style={{ display: 'flex', width: '48%', justifyContent: "space-between" }}>
                <Label
                  size="large"
                  weight="regular"
                  styles={{ fontWeight: '800', color: '#323130' }}
                >
                  <Text className={classes.label}>{t("boarding.province")}</Text>
                </Label>
              </div>

            </div>
            <div
              style={{
                display: 'flex',
                width: '100%',
                justifyContent: 'space-between',
                marginTop: '1%',
              }}
            >
              <div style={{ display: 'flex', width: '48%', justifyContent: "space-between" }}>
                <Text className={classes.value}>{data?.streetPrefix}&nbsp;{companyAddress[2].value}</Text>
              </div>

              <div style={{ display: 'flex', width: '48%', justifyContent: "space-between" }}>
                <Text className={classes.value}>{data?.provincePrefix}&nbsp;{companyAddress[3].value}</Text>
              </div>

            </div>


            <div
              style={{
                display: 'flex',
                width: '100%',
                justifyContent: 'space-between',
                marginTop: '3%',
              }}
            >
              <div style={{ display: 'flex', width: '48%', justifyContent: "space-between" }}>
                <Label
                  size="large"
                  weight="regular"
                  styles={{ fontWeight: '800', color: '#323130' }}
                >
                  <Text className={classes.label}>{t("boarding.district")}</Text>
                </Label>
              </div>

              <div style={{ display: 'flex', width: '48%', justifyContent: "space-between" }}>
                <Label
                  size="large"
                  weight="regular"
                  styles={{ fontWeight: '800', color: '#323130' }}
                >
                  <Text className={classes.label}>{t("boarding.subDistrict")}</Text>
                </Label>
              </div>

            </div>
            <div
              style={{
                display: 'flex',
                width: '100%',
                justifyContent: 'space-between',
                marginTop: '1%',
              }}
            >
              <div style={{ display: 'flex', width: '48%', justifyContent: "space-between" }}>
                <Text className={classes.value}>{data?.districtPrefix}&nbsp;{companyAddress[4].value}</Text>
              </div>

              <div style={{ display: 'flex', width: '48%', justifyContent: "space-between" }}>
                <Text className={classes.value}>{data?.subDistrictPrefix}&nbsp;{companyAddress[5].value}</Text>
              </div>

            </div>

            <div
              style={{
                display: 'flex',
                width: '100%',
                justifyContent: 'space-between',
                marginTop: '3%',
              }}
            >
              <div style={{ display: 'flex', width: '48%', justifyContent: "space-between" }}>
                <Label
                  size="large"
                  weight="regular"
                  styles={{ fontWeight: '800', color: '#323130' }}
                >
                  <Text className={classes.label}>{t("boarding.postCode")}</Text>
                </Label>

              </div>

            </div>
            <div
              style={{
                display: 'flex',
                width: '100%',
                justifyContent: 'space-between',
                marginTop: '1%',
              }}
            >
              <div style={{ display: 'flex', width: '48%', justifyContent: "space-between" }}>
                <Text className={classes.value}>{companyAddress[6].value}</Text>
              </div>

            </div>
            <Divider style={{ marginTop: '2.5%', marginBottom: "2.5%" }} />
            <div
              style={{
                display: 'flex',
                width: '100%',
                justifyContent: 'space-between',
              }}
            >
              <div style={{ display: 'flex', width: '48%', justifyContent: "space-between" }}>
                <Label
                  size="large"
                  weight="regular"
                  styles={{ fontWeight: '800', color: '#323130' }}
                >
                  <Text className={classes.label}>{t("boarding.phone")}</Text>
                </Label>

              </div>

              <div style={{ display: 'flex', width: '48%', justifyContent: "space-between" }}>
                <Label
                  size="large"
                  weight="regular"
                  styles={{ fontWeight: '800', color: '#323130' }}
                >
                  <Text className={classes.label}>{t("boarding.email")}</Text>
                </Label>
              </div>

            </div>
            <div
              style={{
                display: 'flex',
                width: '100%',
                justifyContent: 'space-between',
                marginTop: '2%',
              }}
            >
              <div style={{ display: 'flex', width: '48%', justifyContent: "space-between" }}>
                <Text className={classes.value}>{companyContacts[0].value}</Text>
              </div>

              <div style={{ display: 'flex', width: '48%', justifyContent: "space-between" }}>
                <Text className={classes.value}>{companyContacts[1].value}</Text>
              </div>
            </div>
            <Divider style={{ marginTop: '2.5%', marginBottom: "2.5%" }} />
            <div
              style={{
                display: 'flex',
                width: '100%',
                justifyContent: 'space-between',
              }}
            >
              <div style={{ display: 'flex', width: '48%', justifyContent: "space-between" }}>
                <Label
                  size="large"
                  weight="regular"
                  styles={{ fontWeight: '800', color: '#323130' }}
                >
                  <Text className={classes.label}>{t("boarding.registerVat")}</Text>
                </Label>
              </div>
            </div>
            <div
              style={{
                display: 'flex',
                width: '100%',
                justifyContent: 'space-between',
                marginTop: '1%',
              }}
            >
              <div style={{ display: 'flex', width: '48%', justifyContent: "space-between" }}>
                <Text className={classes.value}>{companyVatRegister[0].value === true ? t('company.registerVatYes') : t('company.registerVatNo')} </Text>
              </div>
            </div>
          </div>
        </div>
      }

    </BoardingStructure >

  );
};

export default CompanyDataPreview;
